module.exports = __webpack_public_path__ + "static/img/incomplete.10c45e5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/incomplete.svg
// module id = k7Bp
// module chunks = 1